import request from '@/router/axios'
import { baseUrl } from '@/config/env'

export const getTopMenu = () => request(`${baseUrl}/user/getTopMenu`)

export const sendLogs = data => request(`${baseUrl}/user/logout`, { data }, 'post')

export const refeshToken = () => request(`${baseUrl}/user/refesh`, null, 'post')
